export interface PremiumPlan {
  readonly durationMonths: number
  readonly id: string
  readonly label: string
  readonly monthlyPrice: number
  readonly originalMonthlyPrice: number
  readonly originalPrice: number
  readonly price: number
  readonly recommended: boolean
}

export const premiumBenefits = [
  'Personalized study plan',
  'Online book series',
  'Vocabulary trainer with flashcards',
  'Guided sentence practice',
] as const

export const premiumPlans: PremiumPlan[] = [
  {
    durationMonths: 3,
    id: 'premium-3-months',
    label: 'Premium',
    monthlyPrice: 9.7,
    originalMonthlyPrice: 26.4,
    originalPrice: 79,
    price: 29,
    recommended: false,
  },
  {
    durationMonths: 12,
    id: 'premium-12-months',
    label: 'Premium',
    monthlyPrice: 4.1,
    originalMonthlyPrice: 16.6,
    originalPrice: 199,
    price: 49,
    recommended: true,
  },
  {
    durationMonths: 24,
    id: 'premium-24-months',
    label: 'Premium',
    monthlyPrice: 3.3,
    originalMonthlyPrice: 12.1,
    originalPrice: 289,
    price: 79,
    recommended: false,
  },
] as const
